/* MX Product Card — behaviour for every .mxcard on the page (event delegation, so it also
   works for cards loaded later by filters, sorting, "load more" or the theme editor). */
(function () {
  if (window.__mxCardInit) return;
  window.__mxCardInit = true;

  var routes = window.routes || {};
  var cartAddUrl = (routes.cart_add_url || '/cart/add') + '.js';

  /* ---------- helpers ---------- */
  function variants(card) {
    if (!card._mxVariants) {
      var el = card.querySelector('[data-mxcard-variants]');
      try { card._mxVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._mxVariants = []; }
    }
    return card._mxVariants;
  }

  function findVariant(card, size, onlyAvailable) {
    var si = parseInt(card.dataset.sizeIndex, 10);
    var ci = parseInt(card.dataset.colorIndex, 10);
    var color = card.dataset.activeColor;
    var list = variants(card).filter(function (v) {
      if (si >= 0 && size != null && v.o[si] !== size) return false;
      if (ci >= 0 && color && v.o[ci] !== color) return false;
      return true;
    });
    if (onlyAvailable) list = list.filter(function (v) { return v.a; });
    return list[0];
  }

  /* sizes follow the selected color */
  function refreshSizes(card) {
    card.querySelectorAll('[data-mxcard-size]').forEach(function (btn) {
      btn.disabled = !findVariant(card, btn.dataset.mxcardSize, true);
    });
    /* a color change can make the chosen size unavailable: clear it */
    var chosen = card.querySelector('[data-mxcard-size].is-selected');
    if (chosen && chosen.disabled) selectSize(card, null);
  }

  /* size click only selects; ADD puts it in the cart */
  function selectSize(card, btn) {
    card.querySelectorAll('[data-mxcard-size]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var add = card.querySelector('[data-mxcard-add]');
    if (add) {
      add.classList.toggle('is-ready', !!btn);
      add.setAttribute('aria-disabled', btn ? 'false' : 'true');
    }
    if (btn) card.dataset.selectedSize = btn.dataset.mxcardSize;
    else delete card.dataset.selectedSize;
  }

  function nudgeSizes(card) {
    var bar = card.querySelector('.mxcard__quick');
    if (!bar) return;
    bar.classList.remove('is-nudge');
    void bar.offsetWidth;
    bar.classList.add('is-nudge');
    showToast('Please choose a size');
  }

  function goToSlide(card, index, smooth) {
    var strip = card.querySelector('[data-mxcard-slides]');
    if (!strip) return;
    var count = strip.children.length;
    index = (index + count) % count;
    strip.scrollTo({ left: index * strip.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }

  function currentSlide(card) {
    var strip = card.querySelector('[data-mxcard-slides]');
    return strip ? Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth)) : 0;
  }

  var toast;
  function showToast(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mxcard-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2000);
  }

  function addToCart(id, quantity) {
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mx-product-card', productVariantId: id });
      }
      return data;
    });
  }

  function quickAdd(btn, variant) {
    if (!variant) return;
    btn.classList.add('is-loading');
    addToCart(variant.id).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      showToast('Added to cart');
      setTimeout(function () {
        btn.classList.remove('is-added');
        var card = btn.closest('[data-mxcard]');
        if (card && btn.hasAttribute('data-mxcard-add')) selectSize(card, null);
      }, 1500);
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      showToast(err.message);
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('[data-mxcard]');
    if (card && !card._mxReady) {
      card._mxReady = true;
      refreshSizes(card);
    }

    /* color-sibling swatch (other product): preview its photo while hovering */
    var sib = e.target.closest && e.target.closest('[data-sibling-image]');
    if (card && sib) {
      var img = card.querySelector('.mxcard__img');
      if (img) {
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.currentSrc || img.src;
          img.dataset.origSrcset = img.getAttribute('srcset') || '';
        }
        img.removeAttribute('srcset');
        img.src = sib.dataset.siblingImage;
        goToSlide(card, 0, false);
      }
    }
  });

  /* photo dashes follow the visible photo */
  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!strip || !strip.matches || !strip.matches('[data-mxcard-slides]')) return;
    var card = strip.closest('[data-mxcard]');
    var dashes = card ? card.querySelectorAll('.mxcard__dash') : [];
    if (!dashes.length) return;
    var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
    dashes.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
  }, true);

  document.addEventListener('mouseout', function (e) {
    var sib = e.target.closest && e.target.closest('[data-sibling-image]');
    if (!sib || (e.relatedTarget && sib.contains(e.relatedTarget))) return;
    var card = sib.closest('[data-mxcard]');
    var img = card && card.querySelector('.mxcard__img');
    if (img && img.dataset.origSrc) {
      img.src = img.dataset.origSrc;
      if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    }
  });

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-mxcard]');
    if (!card) return;

    var prev = e.target.closest('[data-mxcard-prev]');
    var next = e.target.closest('[data-mxcard-next]');
    if (prev || next) {
      e.preventDefault();
      goToSlide(card, currentSlide(card) + (next ? 1 : -1), true);
      return;
    }

    var swatch = e.target.closest('[data-mxcard-color]');
    if (swatch) {
      e.preventDefault();
      card.dataset.activeColor = swatch.dataset.mxcardColor;
      card.querySelectorAll('[data-mxcard-color]').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
      refreshSizes(card);
      var v = findVariant(card, null, true) || findVariant(card, null, false);
      if (v && v.m) {
        var slides = Array.prototype.slice.call(card.querySelectorAll('[data-media-id]'));
        var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(v.m); });
        if (i > -1) {
          goToSlide(card, i, true);
        } else if (v.src) {
          var img = card.querySelector('.mxcard__img');
          if (img) { img.removeAttribute('srcset'); img.src = v.src; }
          goToSlide(card, 0, false);
        }
      }
      return;
    }

    var size = e.target.closest('[data-mxcard-size]');
    if (size) {
      e.preventDefault();
      if (!card._mxReady) { card._mxReady = true; refreshSizes(card); }
      if (size.disabled) return;
      /* clicking the chosen size again un-selects it */
      selectSize(card, size.classList.contains('is-selected') ? null : size);
      return;
    }

    var addBtn = e.target.closest('[data-mxcard-add]');
    if (addBtn) {
      e.preventDefault();
      var chosen = card.dataset.selectedSize;
      if (!chosen) { nudgeSizes(card); return; }
      var variant = findVariant(card, chosen, true);
      if (!variant) { selectSize(card, null); nudgeSizes(card); return; }
      quickAdd(addBtn, variant);
      return;
    }

    var single = e.target.closest('[data-mxcard-single]');
    if (single) {
      e.preventDefault();
      quickAdd(single, findVariant(card, null, true));
      return;
    }
  });

})();
